import React from "react";
import {connect} from "react-redux";
import {URLs} from "../../common/constants";
import {setDirty} from '../../actions/common/commonActions';
import {checkAuthorizeDotNetTokenAndSubmitOrder} from "../../actions/store/storeCheckoutActions";
import {completeSubscription} from '../../actions/join/joinPayActions';
import {checkAuthorizeDotNetTokenAndUpdatePayments, processAuthorizeDotNetResponse} from '../../actions/pay/paymentActions';
import LoadingAnimation from "../../components/common/LoadingAnimation";
import styles from "../../css/payments.less";

if (!window.HostCommunicator) window.HostCommunicator = {};

class PaymentsHost extends React.Component {
    state = {
        showLoading: 'Loading'
    };

    componentWillMount() {
        HostCommunicator.onReceiveCommunication = function (querystr) {
            const params = this.__parseQueryString(querystr);
            switch(params["action"]) {
                case "transactResponse":
                    const response = JSON.parse(params['response']);
                    this.onPaymentDone(response.totalAmount, response.responseCode, response.transId);
                    break;
                case "successfulSave":
                    this.onPaymentDetailsSaved();
                    break;
                case "cancel":
                    this.onPaymentDetailsCanceled();
                    break;
                case "resizeWindow":
                    let height = parseInt(params["height"]).toString();
                    let width = parseInt(params["width"]).toString();
                    let iframe = document.getElementById("paymentsHostIFrame");
                    this.resizeIFrame(iframe, height, width);
                    break;
            }
        }.bind(this);
    }

    __parseQueryString = (str) => {
        let vars = [];
        const arr = str.split('&');
        let pair;
        for (let i = 0; i < arr.length; i++) {
            pair = arr[i].split('=');
            vars.push(pair[0]);
            vars[pair[0]] = unescape(pair[1]);
        }
        return vars;
    };

    resizeIFrame = (iframe, height, width) => {
        iframe.style.height = height.toString() + "px";
        iframe.style.width = width.toString() + "px";
        iframe.style.visibility = 'visible';
        this.setState({showLoading: undefined});
    };

    onPaymentDetailsCanceled = () => {
        if (this.props.pageContext === URLs.CHARGE){
            this.props.closeWindow();
        } else {
            window.history.back();
        }
    };

    onPaymentDone = (amount, responseCode, txId) => {
        this.setState({showLoading: "Please don't close the browser. Processing"});
        document.getElementById("paymentsHostIFrame").style.visibility = 'hidden';
        const flow = this.props.pageContext === URLs.JOIN || this.props.pageContext === URLs.PAY ? 'STANDARD' :
            this.props.pageContext === URLs.STORE ? 'STORE_STANDARD' :
                this.props.pageContext === URLs.CHARGE ? 'CHARGE_FROM_MEMBER_CARD' :
                    '';
        this.props.processAuthorizeDotNetResponse(amount, responseCode, txId, flow);
    };

    onPaymentDetailsSaved = () => {
        this.setState({showLoading: "Please don't close the browser. Processing"});
        document.getElementById("paymentsHostIFrame").style.visibility = 'hidden';
        if (this.props.pageContext === URLs.JOIN) {
            this.props.completeSubscription();
        } else if(this.props.pageContext === URLs.PAY || this.props.pageContext === URLs.CHARGE){
            this.props.checkAuthorizeDotNetTokenAndUpdatePayments();
        } else if(this.props.pageContext === URLs.STORE){
            this.props.checkAuthorizeDotNetTokenAndSubmitOrder();
        }
    };

    render() {
        return (
            <div>
                {this.state.showLoading ?
                    <LoadingAnimation message={this.state.showLoading}/>
                : undefined
                }
                <div>
                    <iframe id="paymentsHostIFrame" name="paymentsHostIFrame" width="100%" height="100%" className="payments-iframe-center"/>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        completeSubscription: () => {
            dispatch(completeSubscription());
        },
        checkAuthorizeDotNetTokenAndUpdatePayments: () => {
            dispatch(checkAuthorizeDotNetTokenAndUpdatePayments());
        },
        checkAuthorizeDotNetTokenAndSubmitOrder: () => {
            dispatch(checkAuthorizeDotNetTokenAndSubmitOrder());
        },
        processAuthorizeDotNetResponse: (amount, responseCode, txnId, flow) => {
            dispatch(processAuthorizeDotNetResponse(amount, responseCode, txnId, flow));
        },
        closeWindow: () => {
            dispatch(setDirty(false));
            window.close();
        }
    }
};

export default connect(null, mapDispatchToProps)(PaymentsHost);



// WEBPACK FOOTER //
// ./src/containers/pay/PaymentsHost.js